import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import Users from '../Users';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const {language} = useOutletContext();
  const [t] = useTranslation();
  return (
    <div className="flex-grow overflow-y-auto content-start bg-slate-50 dark:bg-slate-900 dark:text-white w-full max-w-4xl mx-auto">
        <div className='mt-10 min-h-[10px]'></div>
        <h1 className='mb-10 text-4xl text-center text-blue-400'>{t('Welcome to React')} ---{language}---This is Home</h1>
        <Users />
        <p className="px-5 text-justify text-lg">
        Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia.<br />

It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.<br />

The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen. She packed her seven versalia, put her initial into the belt and made herself on the way. When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then
        </p>
    </div>
  )
}

export default Home